/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcribe_EmptyInputs */

const en_us2_transcribe_empty = /** @type {(inputs: Transcribe_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing was recorded. Hold the mic and try again.`)
};

const pt_br2_transcribe_empty = /** @type {(inputs: Transcribe_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada foi gravado. Segure o microfone e tente de novo.`)
};

const es_419_transcribe_empty = /** @type {(inputs: Transcribe_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se grabó nada. Mantén presionado el micrófono e intenta de nuevo.`)
};

const pt_pt2_transcribe_empty = /** @type {(inputs: Transcribe_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada foi gravado. Mantém o microfone premido e tenta outra vez.`)
};

const fr_fr2_transcribe_empty = /** @type {(inputs: Transcribe_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien n'a été enregistré. Maintiens le micro et réessaie.`)
};

const de_de2_transcribe_empty = /** @type {(inputs: Transcribe_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts aufgenommen. Halte das Mikro gedrückt und versuch's noch mal.`)
};

const it_it2_transcribe_empty = /** @type {(inputs: Transcribe_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato registrato nulla. Tieni premuto il microfono e riprova.`)
};

/**
* | output |
* | --- |
* | "Nothing was recorded. Hold the mic and try again." |
*
* @param {Transcribe_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const transcribe_empty = /** @type {((inputs?: Transcribe_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcribe_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_transcribe_empty(inputs)
	if (locale === "es-419") return es_419_transcribe_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_transcribe_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_transcribe_empty(inputs)
	if (locale === "de-DE") return de_de2_transcribe_empty(inputs)
	if (locale === "it-IT") return it_it2_transcribe_empty(inputs)
	return en_us2_transcribe_empty(inputs)
});
export { transcribe_empty as "transcribe.empty" }